import { NavigateBackLink } from '@exam-center/components';
import {
  useExamEventDetails,
  REGISTRATION_TYPE_LABEL,
  EXAM_TYPE_LABEL,
  type ExamEventData,
  formatExamTime,
} from '@exam-center/exam-event-management';
import { Flex, PageHeader, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

function getExamEventHeaderDetails(examEvent: ExamEventData) {
  const examEventDate = new Date(examEvent.examStartedAt);
  const roundNo = examEvent.roundNumber;

  return {
    headerTitle: `สรุปผลการสอบ: วันที่ ${formatDate(examEventDate)} (เวลา ${formatExamTime(examEvent.examStartedAt, examEvent.examEndedAt)})`,
    roundNo,
    regType: REGISTRATION_TYPE_LABEL[examEvent.registrationType],
    examType: EXAM_TYPE_LABEL[examEvent.examType],
  };
}

interface ExamEventScoreReportHeaderProps {
  examCenterCode: string;
}

export default function ExamEventScoreReportHeader(
  props: Readonly<ExamEventScoreReportHeaderProps>,
) {
  const { examCenterCode } = props;
  const { examEvent } = useExamEventDetails();

  const { headerTitle, roundNo, examType, regType } = getExamEventHeaderDetails(examEvent);

  return (
    <PageHeader
      title={headerTitle}
      subtitleSection={
        <Flex
          sx={{
            justifyContent: 'space-between',
            flex: 1,
          }}
        >
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2'>รอบสอบที่: {roundNo}</Text>
            <Text variant='body2'>Reg Type: {regType}</Text>
            <Text variant='body2'>Exam Type: {examType}</Text>
          </Flex>
        </Flex>
      }
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-events/:examEventId/results'
          params={{
            examCenterCode,
            examEventId: examEvent.id,
          }}
        />
      }
    />
  );
}
